export const START_DATE_CHANGE = 'START_DATE_CHANGE';
export const END_DATE_CHANGE = 'END_DATE_CHANGE';

export const FILTER_BY_AREA_TYPE = 'FILTER_BY_AREA_TYPE';
export const FILTER_BY_AREA_IDENTIFIER = 'FILTER_BY_AREA_IDENTIFIER';
export const FILTER_BY_AREA_CUSTOM = 'FILTER_BY_AREA_CUSTOM';

export const TOGGLE_CUSTOM_AREA_DRAW = 'TOGGLE_CUSTOM_AREA_DRAW';

export const FILTER_BY_TYPE_INJURY = 'FILTER_BY_TYPE_INJURY';
export const FILTER_BY_TYPE_FATALITY = 'FILTER_BY_TYPE_FATALITY';
export const FILTER_BY_NO_INJURY_FATALITY = 'FILTER_BY_NO_INJURY_FATALITY';

export const FILTER_BY_VEHICLE_CAR = 'FILTER_BY_VEHICLE_CAR';
export const FILTER_BY_VEHICLE_TRUCK = 'FILTER_BY_VEHICLE_TRUCK';
export const FILTER_BY_VEHICLE_MOTORCYCLE = 'FILTER_BY_VEHICLE_MOTORCYCLE';
export const FILTER_BY_VEHICLE_BICYCLE = 'FILTER_BY_VEHICLE_BICYCLE';
export const FILTER_BY_VEHICLE_SUV = 'FILTER_BY_VEHICLE_SUV';
export const FILTER_BY_VEHICLE_BUSVAN = 'FILTER_BY_VEHICLE_BUSVAN';
export const FILTER_BY_VEHICLE_SCOOTER = 'FILTER_BY_VEHICLE_SCOOTER';
export const FILTER_BY_VEHICLE_OTHER = 'FILTER_BY_VEHICLE_OTHER';

export const FILTER_BY_CONTRIBUTING_FACTOR = 'FILTER_BY_CONTRIBUTING_FACTOR';

export const CRASHES_ALL_REQUEST = 'CRASHES_ALL_REQUEST';
export const CRASHES_ALL_SUCCESS = 'CRASHES_ALL_SUCCESS';
export const CRASHES_ALL_ERROR = 'CRASHES_ALL_ERROR';

export const CONTRIBUTING_FACTORS_REQUEST = 'CONTRIBUTING_FACTORS_REQUEST';
export const CONTRIBUTING_FACTORS_SUCCESS = 'CONTRIBUTING_FACTORS_SUCCESS';
export const CONTRIBUTING_FACTORS_ERROR = 'CONTRIBUTING_FACTORS_ERROR';

export const CRASHES_YEAR_RANGE_REQUEST = 'CRASHES_YEAR_RANGE_REQUEST';
export const CRASHES_YEAR_RANGE_SUCCESS = 'CRASHES_YEAR_RANGE_SUCCESS';
export const CRASHES_YEAR_RANGE_ERROR = 'CRASHES_YEAR_RANGE_ERROR';

export const CRASHES_DATE_RANGE_REQUEST = 'CRASHES_DATE_RANGE_REQUEST';
export const CRASHES_DATE_RANGE_SUCCESS = 'CRASHES_DATE_RANGE_SUCCESS';
export const CRASHES_DATE_RANGE_ERROR = 'CRASHES_DATE_RANGE_ERROR';

export const CRASHES_MAX_DATE_REQUEST = 'CRASHES_MAX_DATE_REQUEST';
export const CRASHES_MAX_DATE_RESPONSE = 'CRASHES_MAX_DATE_RESPONSE';
export const CRASHES_MAX_DATE_ERROR = 'CRASHES_MAX_DATE_ERROR';

export const GEO_POLYGONS_REQUEST = 'GEO_POLYGONS_REQUEST';
export const GEO_POLYGONS_SUCCESS = 'GEO_POLYGONS_SUCCESS';
export const GEO_POLYGONS_ERROR = 'GEO_POLYGONS_ERROR';

export const MODAL_OPENED = 'MODAL_OPENED';
export const MODAL_CLOSED = 'MODAL_CLOSED';



// WEBPACK FOOTER //
// ./src/constants/action_types.js